import React from 'react';
import { Link } from 'react-router-dom';
import '../../Stylesheets/Public/NotFound.css'; // optional

const NotFound = () => {
  return (
    <div className="not-found-container">
      <h1>404</h1>
      <p>Oops! The page you're looking for doesn't exist.</p>
      <Link to="/" className="go-home-btn">Go Back Home</Link>
    </div>
  );
};

export default NotFound;
